 // @ts-nocheck
/**
 * @file 遍历数组并将它们重新组合成树
 * @author FengGuang(fengguang01@baidu.com)
 */

function getTreeFromArray<T = any, S = any>(
    list: T[],
    level: S[],
    compare: (listItem: T, levelItem: S) => boolean | void
): (T & { children?: T[], parent?: T })[] {
    type TWithChildren = T & { children?: T[], parent?: T };
    if (list.length === 0) {
        return [];
    }
    if (level.length === 0) {
        return list;
    }
    // 建立一个元素和层级的map
    const itemToLevelIndexMap = new Map<TWithChildren, number>();
    list.forEach((item) => {
        level.forEach((levelItem, levelIndex) => {
            if (compare(item, levelItem)) {
                itemToLevelIndexMap.set(item, levelIndex);
            }
        });
    });
    const result: TWithChildren[] = [];
    // 当前元素的路径
    const itemPath: TWithChildren[] = [];
    (list as TWithChildren[]).forEach((item) => {
        if (itemPath.length === 0) {
            result.push(item);
            itemPath.push(item);
            return;
        }
        let pathEndItemLevel = itemToLevelIndexMap.get(itemPath[itemPath.length - 1]) ?? -1;
        let itemLevel = itemToLevelIndexMap.get(item) ?? -1;
        while (itemPath.length > 0 && pathEndItemLevel > -1 && itemLevel > -1 && pathEndItemLevel >= itemLevel) {
            itemPath.pop();
            pathEndItemLevel = itemToLevelIndexMap.get(itemPath[itemPath.length - 1]) ?? -1;
        }
        if (itemPath.length === 0) {
            result.push(item);
            itemPath.push(item);
        }
        else {
            const parentItem = itemPath[itemPath.length - 1];
            parentItem.children = parentItem.children || [];
            parentItem.children.push(item);
            item.parent = parentItem;
            itemPath.push(item);
        }
    });
    return result;
}

export default getTreeFromArray;
